module.exports = __webpack_public_path__ + "img/SKMJ_kc.16b00d42.jpg";